import { TemplateType } from '@components/Common/CommonEnums';
import { TemplateDropdownsProps } from 'types/Dialog.types';

import GranularTemplateDropdown from './GranularTemplateDropdown';
import SingleTemplateDropdown from './SingleTemplateDropdown';

/**
 * Renders template and mapping dropdown selectors for single or granular (MTD/QTD/YTD) configuration
 */
const TemplateDropdowns = ({
  templateType,
  selectedTemplate,
  selectedMapping,
  templateOptions,
  mappingOptions,
  granularData,
  availableGrains,
  templateDisabled,
  onTemplateChange,
  onMappingChange,
  onGranularChange,
  numberOfBlockHeaders,
  blockHeaders,
  onBlockHeaderChange,
  grainBlockHeaders,
  onGrainBlockHeaderChange,
  blockHeaderOptions,
  grainTemplateLookupMap,
}: TemplateDropdownsProps) => {
  if (templateType === TemplateType.SINGLE) {
    const currTemplateBlockHeaderOptions =
      selectedTemplate && blockHeaderOptions
        ? Array.from(blockHeaderOptions.get(selectedTemplate) || new Set<string>()).sort()
        : [];

    return (
      <SingleTemplateDropdown
        selectedTemplate={selectedTemplate}
        selectedMapping={selectedMapping}
        templateOptions={templateOptions}
        mappingOptions={mappingOptions}
        templateDisabled={templateDisabled}
        onTemplateChange={onTemplateChange}
        onMappingChange={onMappingChange}
        numberOfBlockHeaders={numberOfBlockHeaders}
        blockHeaders={blockHeaders}
        onBlockHeaderChange={onBlockHeaderChange}
        blockHeaderOptions={currTemplateBlockHeaderOptions}
      />
    );
  }

  if (templateType === TemplateType.GRANULAR) {
    return (
      <GranularTemplateDropdown
        templateOptions={templateOptions}
        granularData={granularData}
        availableGrains={availableGrains}
        onGranularChange={onGranularChange}
        numberOfBlockHeaders={numberOfBlockHeaders}
        grainBlockHeaders={grainBlockHeaders}
        onGrainBlockHeaderChange={onGrainBlockHeaderChange}
        blockHeaderOptions={blockHeaderOptions}
        grainTemplateLookupMap={grainTemplateLookupMap}
      />
    );
  }

  return null;
};

export default TemplateDropdowns;
